function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "pdf",
  transform: "translate(-0.84 -1.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_977",
  "data-name": "Caminho 977",
  d: "M10.64,10.07H.84V4.71h9.8ZM1.46,9.45H10V5.33H1.46Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_978",
  "data-name": "Caminho 978",
  d: "M3.36,7.56v.87H3.07V6.2H3.9a.81.81,0,0,1,.58.19.7.7,0,0,1,0,1,.89.89,0,0,1-.59.18Zm0-.24H3.9a.58.58,0,0,0,.37-.11.49.49,0,0,0,0-.64.57.57,0,0,0-.35-.13H3.36Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_979",
  "data-name": "Caminho 979",
  d: "M5.07,8.43V6.2h.64a1.11,1.11,0,0,1,.52.13.89.89,0,0,1,.35.37,1.16,1.16,0,0,1,.12.54v.14a1.18,1.18,0,0,1-.12.55.89.89,0,0,1-.35.37,1.12,1.12,0,0,1-.53.13Zm.3-2V8.19h.31A.7.7,0,0,0,6.22,8a.9.9,0,0,0,.19-.6V7.25a.87.87,0,0,0-.18-.59.64.64,0,0,0-.51-.22Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_980",
  "data-name": "Caminho 980",
  d: "M8.4,7.45h-1v1H7.1V6.2H8.5v.24H7.45v.77h1Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_981",
  "data-name": "Caminho 981",
  d: "M17.89,5.17,14.14,1.5H5V3.79h.83V2.33h7.3V6h3.89V16.57H5.87V11.23H5V17.4H17.89ZM14,2.53l2.65,2.66H14Z"
}));

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.05,
    height: 15.9,
    viewBox: "0 0 17.05 15.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.8ef702b9.svg";
export { ForwardRef as ReactComponent };